(function () {
    'use strict';
    // Turns a link into an authenticated (or, with ogr-download-open, anonymous) resource download that
    // goes through the DownloadResource service, so the bearer token is sent and errors are reported
    // the same way as for the projections downloads.
    // Usage: <a class="download-link" href="" ogr-download-resource="1232">Text</a>
    //        <a class="download-link" href="" ogr-download-resource="712" ogr-download-open>Text</a>
    angular
        .module('portalApp')
        .directive('ogrDownloadResource', ['DownloadResource', function (DownloadResource) {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    var busy = false;
                    var hint = angular.element('<span class="download-busy-hint" role="status" style="display:none">preparing download...</span>');
                    element.after(hint);

                    function setBusy(value) {
                        busy = value;
                        element.toggleClass('download-busy', value);
                        element.attr('aria-busy', value ? 'true' : 'false');
                        hint.css('display', value ? 'inline' : 'none');
                    }

                    element.on('click', function (event) {
                        event.preventDefault();
                        if (busy) {
                            return;
                        }
                        setBusy(true);
                        var res = {id: attrs.ogrDownloadResource};
                        var promise;
                        if (angular.isDefined(attrs.ogrDownloadOpen)) {
                            promise = DownloadResource.downloadResourceOpen(res, true);
                        } else {
                            promise = DownloadResource.downloadResource(res, true);
                        }
                        // errors are reported by the http error handler; here only the busy state is cleared
                        promise.finally(function () {
                            setBusy(false);
                        });
                    });
                }
            };
        }]);
})();
